// Official TWORAY logo lockup (master brand pack).
// Responsive brand rule:
//   header (default): full lockup on ≥sm; official standalone T mark on mobile
//   footer (full):    full lockup on all breakpoints
// Never reconstruct the wordmark/descriptor with HTML text.
export function Logo({
  variant = "color",
  className = "",
  full = false,
  lockupClassName = "h-12 w-auto",
  markClassName = "h-10 w-10",
}) {
  const white = variant === "white";
  const lockup = white ? "/logo-white.png" : "/logo-color.png";
  const mark = white
    ? "/brand/icon/tworay-icon-white-512.png"
    : "/brand/icon/tworay-icon-color-512.png";
  const alt = "TWORAY — Technology Advisory & Cyber Security";

  if (full) {
    return (
      <span data-testid="brand-logo" className={`inline-flex items-center ${className}`}>
        <img src={lockup} alt={alt} className={`block ${lockupClassName}`} />
      </span>
    );
  }

  return (
    <span data-testid="brand-logo" className={`inline-flex items-center ${className}`}>
      <img src={lockup} alt={alt} className={`hidden sm:block ${lockupClassName}`} />
      <img src={mark} alt="TWORAY" className={`block sm:hidden ${markClassName}`} />
    </span>
  );
}

// Standalone official T mark (favicon / app icon / small decorative use only).
export function LogoMark({ variant = "color", className = "" }) {
  const src = variant === "white" ? "/brand/icon/tworay-icon-white-512.png" : "/brand/icon/tworay-icon-color-512.png";
  return <img src={src} alt="TWORAY" className={className} data-testid="brand-mark" />;
}
